// extracted by mini-css-extract-plugin
export default {"root":"default-render-loading-cell_root__WSVvp","placeHolderShimmer":"default-render-loading-cell_placeHolderShimmer__nHcWf"};